import React from "react";
import "./button.css";

function Button({
  id,
  className,
  children,
  primary,
  secondary,
  tertiary,
  disabled,
  onClick,
  type,
  style,
  animation,
  color,
  softDisabled
}) {
  let btnClass = tertiary
    ? "btn-tertiary"
    : secondary
    ? "btn-secondary"
    : "btn-primary";

  let classes = [btnClass, className, `${animation ? `animation-${animation}` : ''}`];

  style = style || {};
  if (color) style['--color-primary'] = color;

  if (softDisabled) classes.push('disabled');

  return (
    <button style={style} type={type} onClick={onClick} id={id} className={classes.join(" ")} disabled={disabled}>
      {children}
    </button>
  );
}

export default Button;
